import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useField } from 'formik'

import { Box, CircularProgress, FormControl } from '@mui/material'
import AutocompleteCustom from '@/views/components/autocomplete-custom/index.component'
import useReportsActions from '@/views/reports/hooks/use-reports-actions.hooks'

import { CategoriesList } from '@/state/wagering-contribution/models'
import { wageringSelector } from '@/state/wagering-contribution/slices/index.slices'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

const GamesCategoryFilterType = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  const { getAllCategories } = useReportsActions()

  const { categoriesList, isLoadingCategories } = useSelector(wageringSelector)

  const [fieldGameCategory] = useField('gameCategory')

  let categoryListOptions: any[] = []

  categoriesList !== undefined &&
    categoriesList.forEach((category: CategoriesList) => {
      const object = category.code
      categoryListOptions = [...categoryListOptions, object]
    })

  return (
    <FormControl fullWidth margin="none">
      <AutocompleteCustom
        id="gameCategory"
        name="gameCategory"
        placeholder={
          fieldGameCategory.value === '' || fieldGameCategory.value.length === 0
            ? t('labels.selectCategories')
            : ''
        }
        value={
          Array.isArray(fieldGameCategory.value) ? fieldGameCategory.value : []
        }
        options={categoryListOptions}
        getOptionLabel={(option: any) =>
          categoriesList.find(
            (category: CategoriesList) => category.code === option,
          )?.name || ''
        }
        // chipTags
        limitTags={1}
        multiple
        onChange={(_, newValue: any[]) => {
          const selectedValue =
            newValue.length > 0 ? [newValue[newValue.length - 1]] : []
          handleChangeSearch('gameCategory', selectedValue)
        }}
        onOpen={() => {
          if (categoryListOptions.length === 0) {
            getAllCategories(true)
          }
        }}
        label={t('labels.gameCategory')}
        sx={{ '& .MuiFormControl-root': { marginTop: '8px' } }}
      />
      {isLoadingCategories && (
        <Box position="absolute" right={41} top={17}>
          <CircularProgress variant="indeterminate" size={30} />
        </Box>
      )}
    </FormControl>
  )
}
export default GamesCategoryFilterType
